import { createFrontendModule } from '@backstage/frontend-plugin-api';
import catalogPlugin from '@backstage/plugin-catalog/alpha';
import {
  catalogMessages,
  catalogReactMessages,
  tableMessages,
} from './translations';

/**
 * Catalog with the index page of the "Backstage BYX" v2 design: only the
 * index page loader is replaced (route and entity pages stay the plugin's).
 */
export const byxCatalogPlugin = catalogPlugin.withOverrides({
  extensions: [
    catalogPlugin.getExtension('page:catalog').override({
      factory: originalFactory =>
        originalFactory({
          params: {
            loader: async () => {
              const { ByxCatalogPage } = await import('./ByxCatalogPage');
              return <ByxCatalogPage />;
            },
          },
        }),
    }),
  ],
});

/**
 * pt-BR labels of the catalog filters, row actions and table chrome. The app's
 * translations input only accepts extensions from the app plugin itself,
 * hence a module for `app` rather than an override of the catalog plugin.
 */
export const catalogTranslationsModule = createFrontendModule({
  pluginId: 'app',
  extensions: [catalogReactMessages, catalogMessages, tableMessages],
});
